var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer text-center text-sm-left"},[_vm._v(" SOBECE | Sosyal Beceri Çocuk Eğitimi ")])}
var staticRenderFns = []

export { render, staticRenderFns }